// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  wfhLocations: [],
  totalWfhLocations: 0,
}

export const mutations = {
  SET_WFH_LOCATIONS(state, wfhLocations) {
    state.wfhLocations = wfhLocations
  },
  SET_TOTAL_WFH_LOCATIONS(state, total) {
    state.totalWfhLocations = total
  },
  ADD_WFH_LOCATION(state, wfhLocation) {
    state.wfhLocations.push(wfhLocation)
  },
  EDIT_WFH_LOCATION(state, wfhLocation) {
    const index = state.wfhLocations.findIndex(
      (el) => el.wfh_location_uuid === wfhLocation.wfh_location_uuid
    )
    if (index !== -1) {
      state.wfhLocations.splice(index, 1, wfhLocation)
    }
  },
  DELETE_WFH_LOCATION(state, wfh_location_uuid) {
    const index = state.wfhLocations.findIndex(
      (el) => el.wfh_location_uuid === wfh_location_uuid
    )
    if (index !== -1) state.wfhLocations.splice(index, 1)
  },
}

export const actions = {
  fetchWfhLocations({ commit }, payload) {
    return ApiService.fetchWfhLocations(payload)
      .then((res) => {
        const { data, total } = res.data
        commit('SET_WFH_LOCATIONS', data)
        commit('SET_TOTAL_WFH_LOCATIONS', total)
      })
      .catch((error) => {
        throw error
      })
  },
  addWfhLocation({ commit }, payload) {
    return ApiService.addWfhLocation(payload)
      .then((res) => {
        const wfhLocation = res.data
        commit('ADD_WFH_LOCATION', wfhLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  editWfhLocation({ commit }, payload) {
    return ApiService.editWfhLocation(payload)
      .then((res) => {
        const wfhLocation = res.data
        commit('EDIT_WFH_LOCATION', wfhLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteWfhLocation({ commit }, payload) {
    return ApiService.deleteWfhLocation(payload)
      .then(() => {
        commit('DELETE_WFH_LOCATION', payload.wfh_location_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}
